// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomNounMoveButton = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 100 100',
      x: '0px',
      y: '0px',
    },
    /*#__PURE__*/ React.createElement('title', null, 'dfb_Cursor copy 8'),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        "'data-name'": 'Calque 2',
      },
      /*#__PURE__*/ React.createElement('circle', {
        cx: '40.94',
        cy: '31.97',
        r: '3.73',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: '59.06',
        cy: '31.97',
        r: '3.73',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: '40.94',
        cy: '50',
        r: '3.73',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: '59.06',
        cy: '50',
        r: '3.73',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: '40.94',
        cy: '68.03',
        r: '3.73',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: '59.06',
        cy: '68.03',
        r: '3.73',
      }),
    ),
  );

export { IconCustomNounMoveButton };
